import { signal } from 'services/SignalsService'
import { StoreageService } from 'services/StoreageService'

const toggles = ['intro', 'space', 'sound', 'left', 'turbo']

export const ToggleManager = { init, dispatch }

function init() {
  toggles.forEach((name) => {
    signal.on(`TOGGLE:${name}`, function (value) {
      StoreageService.set(name, value)
    })
  })
}

function dispatch() {
  toggles.forEach((name) => {
    signal.dispatch(`TOGGLE:${name}`, StoreageService.get(name))
  })
}
